/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface TreeToRemoveAppEntityTreeToRemoveWrite { 
    /**
     * Obręb
     */
    district?: string;
    /**
     * Arkusz mapy
     */
    mapSheet?: string;
    /**
     * Numer ewidencyjny
     */
    registryNumber?: string;
    /**
     * Gatunek
     */
    species?: string;
    /**
     * średnica na wysokości 130 cm
     */
    trunkCircumference130?: string;
    /**
     * Wniosek
     */
    application?: string;
    removalReasons?: Array<string>;
    /**
     * Typ obiektu (tree, shrub)
     */
    objectType?: TreeToRemoveAppEntityTreeToRemoveWrite.ObjectTypeEnum;
    /**
     * Wysokość opłaty za usunięcie
     */
    removalFee?: string;
    /**
     * Inna przyczyna usunięcia
     */
    otherRemovalReason?: string;
    /**
     * Uzasadnienie usunięcia
     */
    removalJustification?: string;
    /**
     * Przeznaczenie terenu wycinki
     */
    landDesignation?: string;
}
export namespace TreeToRemoveAppEntityTreeToRemoveWrite {
    export type ObjectTypeEnum = 'tree' | 'shrub';
    export const ObjectTypeEnum = {
        Tree: 'tree' as ObjectTypeEnum,
        Shrub: 'shrub' as ObjectTypeEnum
    };
}


